(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["nci-sitewide-search-app"] = factory();
	else
		root["nci-sitewide-search-app"] = factory();
})(this, function() {
return 